import * as R from 'ramda';

export const getAlreadyAddedCount = (wishlist: any, productId: number) => R.compose(
  R.propOr(0, 'quantityDesired'),
  R.find(R.propEq('productId', productId)),
)(wishlist)
